export const errors = {
    required: 'Required',
    monthError: 'Please Enter Valid DOB',
    dayError: 'Please Enter Valid DOB',
    yearError: 'Please Enter Valid DOB',
    invalid: 'Sorry, that\'s an invalid entry'
};
